export const BASE_URL = "http://49.50.162.61:8088/api";
